import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-remove-file-modal',
  templateUrl: './remove-file-modal.component.html',
  styleUrls: ['./remove-file-modal.component.scss'],
})
export class RemoveFileModalComponent{
  @Input() uploadedFile: string;
  @Input() selectedFileData: any;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Output() deleteDocument: EventEmitter<string> = new EventEmitter();
  uploadingFiles: ModalOptions;
  hideModal: boolean;
  hideModalOnRoute: any = false;
  incorrectFileFormat: boolean;
  problemUploadingFile: boolean;
  isAcmic = false;
  constructor(private acmicService: AcmicService) {
    this.hideModal = false;
    this.incorrectFileFormat = false;
    this.problemUploadingFile = false;
    this.isAcmic = this.acmicService.isACMIC();
    this.uploadingFiles = new ModalOptions({
      additionalClasses: 'modal-lg modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'removeFileModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: this.isAcmic ? 'Remove file' : '',
      modalName: 'remove_files',
    });
  }
  resetHideModal(event): void {
    if (event) {
      this.closeModal.emit(true);
    }
  }
  onClickCancel() {
    this.resetHideModal(true);
  }
  onClickRemove() {
    this.deleteDocument.emit(this.selectedFileData);
    this.resetHideModal(true);
  }
}
